
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox, notification, Skeleton } from 'antd'
import { DeleteOutlined, DownloadOutlined, FileExcelOutlined, SaveOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import { SelectAcademicYear } from '../../../select/SelectAcademicYear';
import { SelectClass } from '../../../select/SelectClass';
import TableView from '../../../../contents/AntTableResponsive';
import { SelectClassConfig } from '../../../select/SelectClassConfig';
import { SelectFeeHead } from '../../../select/SelectFeeHead';


export default function AddFeeDiscard() {

    const [sectionWiseReportForm] = Form.useForm();
    const fetchSectionsWiseReport2 = useStoreActions((state) => state.student.fetchSectionsWiseReport2);
    const sectionWiseListReport2 = useStoreState((state) => state.student.sectionWiseListReport2);
    const feeheadDeleteSave = useStoreActions((state) => state.saccount.feeheadDeleteSave);
    const loading = useStoreState((state) =>  state.student.loading);

    const formSubmit = (value) => {
        let postData: any = {
            academicYear: value.yearId,
            classconfigid: value.sectionId
        }
        fetchSectionsWiseReport2(postData);
    }

    const studentListColumn = [
        { title: 'Student ID', dataIndex: 'customStudentId', key: 'customStudentId', showOnResponse: true, showOnDesktop: true },
        { title: 'Student Name', dataIndex: 'studentName', key: 'studentName', showOnResponse: true, showOnDesktop: true },
        { title: 'Roll', dataIndex: 'studentRoll', key: 'studentRoll', showOnResponse: true, showOnDesktop: true },
        { title: 'Group', dataIndex: 'groupName', key: 'groupName', showOnResponse: true, showOnDesktop: true },
        { title: 'Father', dataIndex: 'fatherName', key: 'fatherName', showOnResponse: true, showOnDesktop: true },
        { title: 'Mother', dataIndex: 'motherName', key: 'motherName', showOnResponse: true, showOnDesktop: true },
        { title: 'Gender', dataIndex: 'studentGender', key: 'studentGender', showOnResponse: true, showOnDesktop: true },
        { title: 'Religion', dataIndex: 'studentReligion', key: 'studentReligion', showOnResponse: true, showOnDesktop: true },
        { title: 'Mobile No.', dataIndex: 'guardianMobile', key: 'guardianMobile', showOnResponse: true, showOnDesktop: true },
    ];

    const [selectedRowKeys, setselectedRowKeys] = useState<any>([]);
    const [selectedValue, setselectedValue] = useState<any>([]);

    const onSelectChange = (selectedRowKeys, value) => {
        setselectedRowKeys(selectedRowKeys);
        setselectedValue(value);
        // console.log(value)
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const onProcess = () => {
        if (selectedValue.length === 0) {
            notification.error({ message: "Please select student" });
            return
        }
        setIsModalVisible(true);
    }

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const submitData = (value) => {
        value.identificationIds = selectedValue.map(item => item.identificationId).join(',');
        feeheadDeleteSave(value);
        setIsModalVisible(false);
        form.resetFields()
        setselectedRowKeys([]);
        setselectedValue([])
    }

    return (
        <>

            <Row>
                <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }} lg={{ span: 20, offset: 4 }} xl={{ span: 20, offset: 4 }}>
                    <Form
                        layout="vertical"
                        id="classConfigInfo"
                        onFinish={formSubmit}
                        form={sectionWiseReportForm}
                    >
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                <Form.Item
                                    name="yearId"
                                    label="Academic Year"
                                    className="title-Text"
                                    rules={[
                                        { required: true, message: "Please select year" },
                                    ]}
                                >
                                    <SelectAcademicYear />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                                <Form.Item
                                    name="sectionId"
                                    label="Select Section"
                                    className="title-Text"
                                    rules={[
                                        { required: true, message: "Please select section" },
                                    ]}
                                >
                                    <SelectClassConfig />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                                <Space size="small" >
                                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} >
                                        Search
                                    </Button>
                                </Space>
                            </Col>
                        </Row>

                    </Form>
                </Col>
            </Row>
            {sectionWiseListReport2 ===null && < Skeleton loading={loading} paragraph={{rows:10}} />}
            <Row style={{ display: sectionWiseListReport2.length > 0 ? '' : 'none' }}>
                <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }}>
                    <TableView
                        antTableProps={{
                            showHeader: true,
                            columns: studentListColumn,
                            rowKey: "identificationId",
                            dataSource: sectionWiseListReport2,
                            filterData: sectionWiseListReport2,
                            pagination: false,
                            bordered: true,
                            rowSelection: rowSelection,
                        }}
                        mobileBreakPoint={768}
                    />
                    {/* <Button type="primary" htmlType="submit" icon={<DeleteOutlined />} onClick={() => deleteStudent()} className="float-right">Delete</Button> */}
                </Col>
                <Col span={24}>
                <Space size="small" style={{ float: "right", marginTop:15 }}>

                        <Button type="primary" icon={<SettingOutlined />} onClick={() => onProcess()} >Process</Button>
                    </Space>
                </Col>
            </Row>
            <Modal
                title="Fee Discard"
                visible={isModalVisible}
                // onOk={handleOk}
                // okButtonProps={{ form: 'update', htmlType: 'submit' }}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                centered
            >
                <Form
                    layout="vertical"
                    onFinish={submitData}
                    id="basic-info"
                    form={form}
                >
                    <Row gutter={8}>
                        <Col xs={24}>
                            <Form.Item
                                name="feeHeadId"
                                label="Fee Head"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please select fee head" },
                                ]}
                            >

                                <SelectFeeHead />
                            </Form.Item>
                        </Col>
                    </Row>
                    <div style={{ textAlign: 'right' }}>
                        <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SaveOutlined />}>
                            Save
                        </Button>
                    </div>
                </Form>

            </Modal>

        </>
    )
}
